var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", { staticClass: "title" }, [_vm._v("Draw test")]),
      _vm._v(" "),
      _c("handwrite-input", {
        attrs: { "canvas-height-default": 300 },
        model: {
          value: _vm.imageData,
          callback: function ($$v) {
            _vm.imageData = $$v
          },
          expression: "imageData",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }